




















import { defineNuxtComponent } from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineNuxtComponent({
  head() {
    return {
      title: this.$t('about_us')
    }
  },
  i18n: defineComponentTranslations({
    car_company_gemi: {
      en: 'GEMI (Business Registry Number): 135823728000',
      el: 'ΓΕΜΗ: 135823728000'
    },
    car_company_vat: {
      en: 'VAT Number: 800680758',
      el: 'ΑΦΜ: 800680758'
    },
    car_company_telephone: {
      en: 'Phone: 2665022233 - 6932195338',
      el: 'Τηλέφωνο: 2665022233 - 6932195338'
    },
    car_company_name: {
      en: 'Company name: EL.CAR.GR I.K.E',
      el: 'Επωνυμία: EL.CAR.GR Ι.Κ.Ε'
    },
    car_company_address: {
      en: 'Address: 4 Fotiou Michala Street, Igoumenitsa, Thesprotia, 46100',
      el: 'Διεύθυνση: ΦΩΤΙΟΥ ΜΙΧΑΛΑ 4, ΗΓΟΥΜΕΝΙΤΣΑ ΘΕΣΠΡΩΤΙΑΣ, 46100'
    },
    car_company_activity: {
      en:
        'The company, in addition to its main activity, which is "WEB HOSTING SERVICES," also operates as a "Mortgage Credit Intermediary," supervised by the Bank of Greece.',
      el:
        'Η εταιρεία παράλληλα με την κύρια δραστηριότητά της που είναι οι "ΥΠΗΡΕΣΙΕΣ ΙΣΤΟΦΙΛΟΞΕΝΙΑΣ (WEB HOSTING)" ασκεί και την δραστηριότητά του "Μεσίτη στεγαστικής Πίστης" και η οποία είναι εποπτευόμενη από την Τράπεζα της Ελλάδος.'
    }
  })
})
